/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetEquipmentDetailsRequest = {
  /**
   * The id of the device to get the equipment details view for
   */
  deviceId: string;
  agentId: string;
};

/** @internal */
export const GetEquipmentDetailsRequest$inboundSchema: z.ZodType<
  GetEquipmentDetailsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  device_id: types.string(),
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "device_id": "deviceId",
    "agent_id": "agentId",
  });
});
/** @internal */
export type GetEquipmentDetailsRequest$Outbound = {
  device_id: string;
  agent_id: string;
};

/** @internal */
export const GetEquipmentDetailsRequest$outboundSchema: z.ZodType<
  GetEquipmentDetailsRequest$Outbound,
  z.ZodTypeDef,
  GetEquipmentDetailsRequest
> = z.object({
  deviceId: z.string(),
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    deviceId: "device_id",
    agentId: "agent_id",
  });
});

export function getEquipmentDetailsRequestToJSON(
  getEquipmentDetailsRequest: GetEquipmentDetailsRequest,
): string {
  return JSON.stringify(
    GetEquipmentDetailsRequest$outboundSchema.parse(getEquipmentDetailsRequest),
  );
}
export function getEquipmentDetailsRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetEquipmentDetailsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetEquipmentDetailsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetEquipmentDetailsRequest' from JSON`,
  );
}
